import React, {Component} from 'react';
import {connect} from "react-redux";
import withStyles from "@material-ui/core/es/styles/withStyles";
import Table from "@material-ui/core/es/Table";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/es/TableRow";
import TableCell from "@material-ui/core/es/TableCell";
import TableHead from "@material-ui/core/TableHead";


const styles = theme => ({
    tableContainer: {
        overflowX: 'auto', 
        marginBottom: '50px',
        borderTop: '1px solid rgba(0, 0, 0, 0.13)',
        borderLeft: '1px solid rgba(0, 0, 0, 0.13)',
        borderRight: '1px solid rgba(0, 0, 0, 0.13)',
        borderRadius: '5px'
    },
    tableCell: {
        fontSize: '14px',
        borderRight: '1px solid rgba(0, 0, 0, 0.13)',
    },
    tableRow: {
        '& th:last-child': {
            borderRight: 'none',
        }
    }
  });

class InvoicesTable extends Component {

    convertToLocale = value => {
        let parsedValue = parseInt(value);
        if (!isNaN(parsedValue)) {
            const date = new Date(parsedValue.toString().length === 10 ? parsedValue * 1000 : parsedValue);
            return date.toLocaleString();
        }
        return "N/A";
    };

    AmmountPaid = (amount_paid, currency) => {
        if(amount_paid){
            let money = amount_paid / 100;       
            if(currency){
                money = money.toLocaleString("en-US", {style:"currency", currency:currency});
            }                 
        return <div>{money}</div>                    
        }else{
          return <div></div>
        }
      }

    render() {
       let { billing: {invoicesContent, error}, classes } = this.props;
        return (
            invoicesContent && invoicesContent.length > 0 && 
            <div className={classes.tableContainer}>
                <Table>
                    <TableHead>
                        <TableRow className={classes.tableRow}>
                            <TableCell className={classes.tableCell}>Created</TableCell>
                            <TableCell className={classes.tableCell}>Amount due</TableCell>
                            <TableCell className={classes.tableCell}>Amount paid</TableCell>
                            <TableCell className={classes.tableCell}>Amount remaining</TableCell>
                            <TableCell className={classes.tableCell}>Status</TableCell>
                        </TableRow>
                    </TableHead>
                        <TableBody>
                        {invoicesContent.map(invoice => {
                            return <TableRow className={classes.tableRow} key={invoice.id}> 
                                <TableCell className={classes.tableCell}>{this.convertToLocale(invoice.created)}</TableCell>
                                <TableCell className={classes.tableCell}>{this.AmmountPaid(invoice.amount_due, invoice.currency)}</TableCell>
                                <TableCell className={classes.tableCell}>{this.AmmountPaid(invoice.amount_paid, invoice.currency)}</TableCell>
                                <TableCell className={classes.tableCell}>{this.AmmountPaid(invoice.amount_remaining, invoice.currency)}</TableCell>
                                <TableCell className={classes.tableCell}>{invoice.status}</TableCell>
                            </TableRow>
                        })}
                    </TableBody>
                </Table>
            </div> 
        
                   
        );
    }
}

const mapStateToProps = ({infoModal, billing}) => ({infoModal, billing});

export default connect(mapStateToProps, {})(withStyles(styles)(InvoicesTable));


// WEBPACK FOOTER //
// ./src/containers/billing/components/InvoicesTable.js